import { buildConversionAnalyticsEvent, type ConversionAnalyticsEvent } from '../../../shared/analytics/conversionEvents';
import { trackEvent } from './core';

export function trackConversionEvent(
  input: ConversionAnalyticsEvent,
): void {
  trackEvent(buildConversionAnalyticsEvent(input));
}
